window.Service = {
	updatePrices: function ($container) {
		let service_price_id = $container.find('[name=service_price_id]:checked').val()
			|| $container.find('[name=service_price_id]').val();

		let params = {
			date: $container.find('.refDate').val(),
			service_price_id: service_price_id
		};

		let $slots = $container.find('.calendar-slots');

		$.get('/services/check_times', params, function (data) {
			for (let time of data.times) {
				let $time = $slots.find(`.slot[data-time="${time.time}"]`);
				$time.attr('data-status', time.status)
					.data('status', time.status)
					.attr('data-fulldate', time.fulldate)
					.data('fulldate', time.fulldate)
				;

				$time.closest('.item-slot')
					.attr('data-status', time.status)
					.data('status', time.status)
			}

			let $activeSlots = $slots.find('[data-status="0"]');
			let $empty = $container.find('.wrapper-slot-empty');
			if ($activeSlots.length) {
				$empty.addClass('d-none');
			} else {
				$empty.removeClass('d-none');
			}
		});
	}
};

$(document).ready(function () {
	$('.rescalendar').each(function (i, e) {
		let calsize = $(e).data('calsize') || 10;

		$(e).rescalendar({
			id: 'rescal',
			format: 'DD.MM.YYYY',
			refDate: $(e).data('date'),
			data: [],
			dataKeyField: 'name',
			dataKeyValues: [''],
			locale: 'ru',
			jumpSize: calsize / 2,
			calSize: calsize,
			disabledDays: [],
			disabledWeekDays: [],
			lang: {
				'init_error': 'Error when initializing',
				'no_data_error': 'No data found',
				'no_ref_date': 'No refDate found',
				'today': 'Сегодня'
			}
		});

		$(e).find('.move_to_tomorrow, .move_to_yesterday').attr('type', 'button').text('');
	})

	let $serviceBooking = $('.booking-container-main');
	$serviceBooking.find('[name=service_price_id]').change(function () {
		Service.updatePrices($serviceBooking);

		let id = $(this).val();
		$serviceBooking.find('.slot').each(function (i, e) {
			$(e).data('service_price_id', id);
		});

		$serviceBooking.find('.form-check').removeClass('active');
		$(this).closest('.form-check').addClass('active');
	});

	$serviceBooking.find('#pills-servicePriceTypeContent .form-check').click(function () {
		$([document.documentElement, document.body]).animate({
			scrollTop: $serviceBooking.find(".calendar-container").offset().top - 150
		}, 500);
	});

	$('.rescalendar-main').find('.refDate').on('update', function () {
		Service.updatePrices($serviceBooking);
	});

	if ($serviceBooking.length) {
		setInterval(function () {
			Service.updatePrices($serviceBooking);
		}, 1000 * 10);
	}

	$(document).on('submit', '#form-cart-service', function () {
		var route = $(this).attr('action');
		var params = $(this).serializeArray();
		var $modal = $(this).closest("#modal-cart-service");

		var $btn = $modal.find('.btn-submit');
		var prevText = $btn.text();
		$btn.text('Бронируем время...').attr('disabled', 'disabled');

		var $msgError = $modal.find('.msg.msg-error');
		$msgError.hide();

		$.post(route, params, function (data) {
			$btn.text(prevText).removeAttr('disabled');
			if (data.error) {
				$msgError.text(data.msg).show();
			} else {
				yaCounterReachGoal('order-service');
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	// next prev step navigation
	$(document).on('click', '#modal-cart-service-content [data-next]', function () {
		let to = $(this).data('to');
		let $to = $(to);
		let $from = $(this).closest('.step-container');

		let valid = true;
		$from.find('input, textarea').each(function (i, e) {
			let elem = $(e)[0];
			if (!elem.validity.valid) {
				valid = false;
				elem.reportValidity();
				return;
			}
		})

		if (valid) {
			$from.hide();
			$to.show();
		}
	});

	$(document).on('click', '#modal-cart-service-agreement .btn-to-agreement', function () {
		let type = $(this).data('to-type');
		let $container = $(this).closest('#modal-cart-service-agreement');
		let $content = $container.find(`.agreement-content[data-type=${type}]`);
		let $ask = $container.find('.agreement-ask');

		$content.removeClass('d-none');
		$ask.addClass('d-none');

		$content.find('input').each(function () {
			if ($(this).hasClass('required'))
				$(this).attr('required', 'required');
			$(this).removeAttr('disabled');
		});
	})

	$(document).on('show.bs.tab', '#service-booking #pills-tab-record a', function () {
		let $target = $($(this).data('target'));
		let $checkbox = $target.find('[name=service_price_id]').first();

		$target.find('.form-check').removeClass('active')

		$checkbox.prop('checked', true).trigger('change');
		$checkbox.closest('.form-check').addClass('active');

		$([document.documentElement, document.body]).animate({
			scrollTop: $("#pills-servicePriceTypeContent").offset().top - 150
		}, 500);
	});
});
